module.exports = __webpack_public_path__ + "static/media/zu-ZA.cfbec006.md";